import ApplicationSerializer from 'admin-panel/serializers/application';

import type Model from '@ember-data/model';

export default class RoomControlIrDeviceSerializer extends ApplicationSerializer {
  normalize(typeClass: Model, hash: Record<string, unknown>, _prop: string) {
    hash['room_control_configuration_id'] = hash['configuration_id'];
    delete hash['configuration_id'];

    hash['room_control_ir_code_set_id'] = hash['ir_code_set_id'];
    delete hash['ir_code_set_id'];

    return super.normalize(typeClass, hash, _prop);
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'room-control/ir-device': RoomControlIrDeviceSerializer;
  }
}
